import { Card } from '@/common/components/atoms/Card/Card';
import { CardContent } from '@/common/components/atoms/Card/Card.Content';
import { CardHeader } from '@/common/components/atoms/Card/Card.Header';

export const WelcomeSvg = () => (
  <svg
    width="96"
    height="91"
    viewBox="0 0 96 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={'mx-auto mb-4'}
  >
    <circle cx="47.6445" cy="52" r="39" fill="#DBE2FA" />
    <path
      d="M40.2151 21.8391C42.4365 24.1806 41.5465 31.4924 40.8239 34.8557L41.3648 34.7109L56.9653 14.7264C57.6949 13.7918 58.7509 13.1675 59.9214 12.9787L60.0186 12.9631C63.0137 12.4801 65.6544 14.9639 65.3555 17.983C65.2786 18.7601 65.0061 19.5051 64.5634 20.1484L54.2718 35.1048L69.188 19.4844C69.9458 18.6908 70.9735 18.2101 72.0684 18.1372C74.9745 17.9435 77.2587 20.5842 76.6485 23.4321L76.6042 23.6393C76.4479 24.3689 76.1144 25.0488 75.6332 25.6189L61.3399 42.5549L77.5713 29.9786C77.7671 29.8269 77.9772 29.6947 78.1988 29.584C80.9736 28.1966 84.1507 30.5431 83.6406 33.6033L83.5765 33.9878C83.4397 34.809 83.0496 35.567 82.4609 36.1557L78.8661 39.7505L68.1556 49.7389L77.8527 43.9402C79.6803 42.8474 82.0484 43.761 82.6684 45.7981C83.074 47.1306 82.5945 48.5718 81.4739 49.399C76.3216 53.2025 68.1455 59.3548 66.1934 61.2067L66.1318 61.2054L60.6117 66.1336C58.01 68.6018 42.0376 79.1211 28.925 65.3C15.8124 51.4789 32.0808 23.6862 33.3816 22.4521C34.6824 21.2179 37.4383 18.9123 40.2151 21.8391Z"
      fill="white"
    />
    <path
      d="M40.825 34.4527C41.5477 31.0894 42.4376 23.7776 40.2162 21.4361C37.4394 18.5093 34.6835 20.8149 33.3827 22.0491C32.0819 23.2832 15.8135 51.0759 28.9261 64.897C42.0387 78.7181 58.0112 68.1988 60.6128 65.7306L66.1329 60.8024"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M41.1452 34.4604L56.7457 14.4759C57.4753 13.5413 58.5313 12.917 59.7018 12.7282L59.7989 12.7126C62.7941 12.2296 65.4348 14.7135 65.1359 17.7325V17.7325C65.059 18.5096 64.7865 19.2546 64.3438 19.8979L54.0521 34.8543L68.9684 19.2339C69.7262 18.4403 70.7539 17.9596 71.8488 17.8867V17.8867C74.7549 17.693 77.0391 20.3337 76.4289 23.1816L76.3845 23.3888C76.2282 24.1184 75.8948 24.7983 75.4136 25.3684L61.1203 42.3044L77.3517 29.7281C77.5475 29.5764 77.7576 29.4442 77.9791 29.3335V29.3335C80.754 27.9461 83.931 30.2926 83.421 33.3528L83.3569 33.7373C83.2201 34.5585 82.83 35.3165 82.2413 35.9052L78.6465 39.5L67.936 49.4884L77.6331 43.6897C79.4607 42.5969 81.8288 43.5105 82.4488 45.5476V45.5476C82.8544 46.8801 82.3749 48.3213 81.2543 49.1485C76.102 52.952 67.9258 59.1043 65.9738 60.9562"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M50.1596 49.6165C47.8838 43.3435 43.396 40.6033 40.6871 39.7604C40.1332 39.588 39.7552 39.0297 39.8855 38.4645L41.1445 33"
      stroke="black"
      strokeWidth="2"
    />
    <mask id="mask0_1409_1195" maskUnits="userSpaceOnUse" x="8" y="13" width="79" height="78">
      <circle cx="47.6445" cy="52" r="39" fill="#F4F6FD" />
    </mask>
    <g mask="url(#mask0_1409_1195)">
      <path
        opacity="0.52"
        d="M44.6445 85.5C35.0445 73.9 21.3112 64 15.1445 60C12.6445 60.8333 6.44453 64.9 1.64453 74.5C6.44453 86.1 23.6445 96.3333 31.6445 100C33.8112 98.3333 40.6445 94.5 44.6445 85.5Z"
        fill="#007AFF"
      />
    </g>
    <path
      d="M10.3663 22.9997C13.7361 29.0546 9.49497 40.0666 5.80918 37.0807C2.6057 34.4856 12.026 30.2458 16.9853 38.9439"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M69.9043 88.5295C68.4043 84.5293 62.4043 81.5293 55.669 83.5137"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M71.6133 79.7598C72.6035 79.5425 75.4013 79.5345 78.6707 81.2407"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M19.6055 21.0166C20.1086 21.8967 20.9519 24.5644 20.3 28.1942"
      stroke="black"
      strokeWidth="2"
    />
  </svg>
);
